// 中文翻译
const cn = {
  shhwyh: "审核委员会",
  tmwyh: "提名委员会",
  xcwyh: "薪酬委员会",
  date: "日期",
  category: "类别",
  chairperson: "主席",
  member: "成员",
  more: "查看更多",
  download: "下载",
  desc: "文件",
  empty: "暂无数据",
  emptyAnnouncements: "暂无公告及通函",
  emptyFinancial: "暂无财务业绩",
  detail: "查看",
};
// 繁体翻译
const tw = {
  shhwyh: "審核委員會",
  tmwyh: "提名委員會",
  xcwyh: "薪酬委員會",
  date: "日期",
  category: "類別",
  chairperson: "主席",
  member: "成員",
  more: "查看更多",
  download: "下載",
  desc: "文件",
  empty: "暫無數據",
  emptyAnnouncements: "暫無公告及通函",
  emptyFinancial: "暫無財務業績",
  detail: "查看",
};
// 英文翻译
const en = {
  shhwyh: "Audit Committee",
  tmwyh: "Nomination Committee",
  xcwyh: "Remuneration Committee",
  date: "Date",
  category: "Category",
  chairperson: "Chairperson",
  member: "Member",
  more: "More",
  download: "Download",
  desc: "Document",
  empty: "Empty",
  emptyAnnouncements: "Announcements Empty",
  emptyFinancial: "Financial Performance Empty",
  detail: "Detail",
};
export { cn, tw, en };
